export default "__VITE_ASSET__5ac22e41__"